import utils from '@/utils';
export default {
  timeFormat: function timeFormat() {
    var _utils$time;

    return (_utils$time = utils.time).format.apply(_utils$time, arguments);
  }
};